import styled from 'styled-components';
import getGutter from '../helpers/getGutter/getGutter';

const RowStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: -${(props) => props.$gutter / 2}px;
  width: calc(100% + ${(props) => props.$gutter}px);
`;

/**
 * @param {RowType} props
 * @returns {React.ReactElement} The rendered component
 */
const Row = ({ className, children, gutter, dataId }) => (
  <RowStyled className={className} $gutter={getGutter(gutter)} data-id={dataId}>
    {children}
  </RowStyled>
);

export default Row;
